module.exports = __webpack_public_path__ + "static/img/product_lotus2r_hero.e532275.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_lotus2r_hero.jpg
// module id = v2o2
// module chunks = 1